import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-31",
  name: "Otherhand",
  slug: "otherhand",
  title: "Otherhand — a Fable World: agency page",
  description:
    "An original agency landing page designed by Fable: a peeling deck of work, violet ink-bleed transitions, Gambetta display."
};

export default meta;
